// extracted by mini-css-extract-plugin
export default {"wrapper":"ResendForgottenPassword_wrapper__VfeVs","button":"ResendForgottenPassword_button__mKGj7"};